module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.2527bfff.webp";